<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Fotografías - {{siniestroConsultado}}</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar');" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0 overflow-none">
  <mat-tab-group #fotografias (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="true"
    mat-align-tabs="center" color="primary">
    @for (opcion of seccionesFotografias; track trackByTab(index, opcion); let index = $index) {
      <mat-tab [label]="opcion">
        <ng-template mat-tab-label>
          {{opcion.descripcion}} ({{opcion.Fotografias?.length || 0}})
        </ng-template>
        <div class="contenedor-panel">
          <app-documentos-seccion-complemento #documentosSeccionComplemento [infoArchivo]="opcion" [siniestroConsultado]="siniestroConsultado"
            [tabId]="index" (resumenFinal)="consultaTodasFotografias($event)">
          </app-documentos-seccion-complemento>
          @if (opcion.Fotografias?.length) {
            <div class="galeria-container my-4">
              <!-- Vista principal -->
              <div class="main-view">
                <button class="nav-btn prev" (click)="prevArchivo()"
                [disabled]="activeIndex === 0">&#10094;</button>
                @switch (obtenerType(opcion.Fotografias[activeIndex]?.nombre)) {
                  @case ('imagen') {
                    <img height="200" width="200"
                      [src]="obtenerSrcArchivo(opcion.Fotografias[activeIndex]) | noImagen"
                      [alt]="opcion.Fotografias[activeIndex].nombre" />
                  }
                  @case ('video') {
                    <video controls autoplay muted loop>
                      <source [src]="obtenerSrcArchivo(opcion.Fotografias[activeIndex])" type="video/mp4" />
                    </video>
                  }
                  <!-- <ngx-extended-pdf-viewer *ngSwitchCase="'pdf'" height="200" width="200"
                  [src]="obtenerSrcArchivo(opcion.Fotografias[activeIndex])"
                ></ngx-extended-pdf-viewer> -->
                @case ('pdf') {
                  <iframe [src]="opcion.Fotografias[activeIndex].url" style="width: 100%; height: 600px;">
                  </iframe>
                }
                @case ('otro') {
                  <p class="txt-primario">No hay renderización de este tipo de formato</p>
                }
              }
              <button class="nav-btn next" (click)="nextArchivo()"
                [disabled]="activeIndex === opcion.Fotografias.length - 1">&#10095;
              </button>
              <p class="caption">{{ opcion.Fotografias[activeIndex]?.nombre }}</p>
              <div class="d-flex justify-content-center">
                <button mat-raised-button color="accent"
                  (click)="eliminarFotografia(opcion.Fotografias[activeIndex])">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
            <!-- Miniaturas -->
            <div class="thumbnails">
              @for (item of opcion.Fotografias; track item; let i = $index) {
                <div class="thumb"
                  [class.active]="i === activeIndex" (click)="activeIndex = i">
                  <img [src]="obtenerSrcMiniaturaArchivo(item) | noImagen" />
                </div>
              }
            </div>
          </div>
        }
        <div class="row mx-md-0 justify-content-md-end">
          <div class="col-md-auto col-auto">
            <button type="submit" color="primary" class="mx-1 my-1" mat-raised-button
              (click)="generaExpedienteElectronico()">
              Guardar
            </button>
          </div>
          <div class="col-md-auto col-auto">
            <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button
              (click)="this.closeDialog('Cancelar');">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </mat-tab>
  }
</mat-tab-group>
</mat-dialog-content>